/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useRef } from 'react';
import { Grid, Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';

const products = [
  {
    icon: 'images/theme/commonImages/studentResources/paraphraser-icon.svg',
    title: 'Paraphraser',
    text: 'Refine, enhance, or simply reword your written work.',
    url: 'https://quillbot.com/',
  },
  {
    icon: 'images/theme/commonImages/studentResources/grammar-icon.svg',
    title: 'Grammar Checker',
    text: 'Polish your work by addressing punctuation, spelling, and word misuse.',
    url: 'https://quillbot.com/grammar-check',
  },
  {
    icon: 'images/theme/commonImages/studentResources/summarizer-icon.svg',
    title: 'Summarizer',
    text: 'Summarize news, articles, long emails, or even your own writing.',
    url: 'https://quillbot.com/summarize',
  },
  {
    icon: 'images/theme/commonImages/studentResources/citation-icon.svg',
    title: 'Citation Generator',
    text: 'Get perfect APA, MLA, and Chicago style citations in one click.',
    url: 'https://quillbot.com/citation-generator',
  },
];

interface StudentHeroProps {
  clickHandler: (event: React.MouseEvent<HTMLAnchorElement>, tabName: string) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '64px 16px',
    maxWidth: 1142,
    margin: '0 auto',
    [theme.breakpoints.down('md')]: {
      padding: '40px 16px 56px',
    },
  },
  heroTextWrapper: {
    margin: '0 auto',
    textAlign: 'center',
  },
  pageTitle: {
    maxWidth: 642,
    margin: '0 auto',
    fontSize: 30,
    fontWeight: 400,
  },
  heroSubtext: {
    margin: '0 auto',
    maxWidth: '528px',
    fontSize: 16,
    marginTop: 24,
    color: theme.specialColors.ICON_DEFAULT_COLOR,
    marginBottom: 64,
    [theme.breakpoints.down('md')]: {
      marginBottom: 48,
    },
  },
  productCard: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    padding: '16px 20px',
    textAlign: 'center',
    borderRadius: 4,
    boxShadow: theme.shadows[2],
  },
  productTitle: {
    marginTop: 16,
    fontSize: 16,
    fontWeight: 600,
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
  },
  productIcon: {
    width: 56,
    height: 56,
  },
  productText: {
    marginTop: 8,
    fontSize: 16,
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
    color: theme.specialColors.ICON_DEFAULT_COLOR,
  },
  productAction: {
    display: 'block',
    marginTop: 24,
    color: theme.specialColors.BLUE_COLOR,
    cursor: 'pointer',
  },
}));

export default function HeroSection(props: StudentHeroProps) {
  const isMobile = useSelector((rootState: RootState) => rootState.common.platform.isMobile);
  const classes = useStyles();

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item className={classes.heroTextWrapper}>
          <h1 className={classes.pageTitle}>
            QuillBot helps students succeed by enhancing their writing and research abilities.
          </h1>
          <div className={classes.heroSubtext}>
            The QuillBot platform utilizes cutting-edge AI to give students instant feedback,
            helping them see opportunities for improvement.
          </div>
        </Grid>
        <Grid container spacing={isMobile ? 3 : 4} style={{ overflow: 'hidden' }}>
          {products.map((product) => (
            <Grid item xs={6} md={3} key={product.icon}>
              <div className={classes.productCard}>
                <div>
                  <img src={product.icon} alt={product.title} />
                  <div className={classes.productTitle}>{product.title}</div>
                  <div className={classes.productText}>{product.text}</div>
                </div>
                <a
                  className={classes.productAction}
                  onClick={(e) => props.clickHandler(e, product.title)}
                >
                  Learn More
                </a>
              </div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
}
